import React from 'react';
import { LogoutOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import {
  VDSSalesCancellationView,
  VDSSalesPromotionMessagesView,
  VDSStatisticsSendView,
  VDSTransmissionCancellationView,
  VDSTransmissionStatisticsView,
} from '../../containers';
import './VDSTools.css';
import { withTranslation } from 'react-i18next';
import { history } from '../../store';
import { Route, Router, Switch, withRouter } from 'react-router-dom';
import { links } from '../../utils';
import { Admin } from '../../utils/roles';
import pkg from '../../../package.json';
import { Logo } from '../../components';
import PropTypes from 'prop-types';
import {
  goToVDSOfferCancelRequest,
  goToVDSOfferRequest,
  goToVDSReportRequest,
  goToVDSTransferCancelRequest,
  goToVDSTransferRequest,
} from '../../utils/gotoLink';

const { Content } = Layout;
const { Sider } = Layout;
const { SubMenu } = Menu;

class VDSTools extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  handleClick = (event) => {
    const menuHandlers = {
      reportRequest: () => goToVDSReportRequest(),
      transferRequest: () => goToVDSTransferRequest(),
      transferCancelRequest: () => goToVDSTransferCancelRequest(),
      offerRequest: () => goToVDSOfferRequest(),
      offerCancelRequest: () => goToVDSOfferCancelRequest(),
    };

    menuHandlers[event.key] && menuHandlers[event.key]();
  };

  determineActive = (path) => {
    const parts = path.split('/');
    let lastPart = parts.pop();
    if (!lastPart) {
      lastPart = parts.pop();
    }
    return [lastPart];
  };

  render() {
    const { t } = this.props;
    const componentToFunction = (component) => (props) =>
      React.createElement(component, props);

    return (
      <Router history={history}>
        <Layout className="vds-tools">
          <Sider className="sidebar" width="300">
            <div className="sidebar__main">
              <Logo t={t} />
              <hr />
              <div className={'clearfix'}>
                <a href={links.oauthLogout} className={'pull-right'}>
                  <LogoutOutlined />{' '}
                </a>
              </div>
            </div>
            <Menu
              mode="inline"
              defaultOpenKeys={['vdsTools']}
              onClick={this.handleClick}
              selectedKeys={this.determineActive(this.props.location.pathname)}
            >
              <SubMenu key="vdsTools" title={<span>{'VDS tööriist'}</span>}>
                <Menu.Item key="reportRequest">{'Statistics report'}</Menu.Item>
                <Menu.Item key="transferRequest">
                  {'Statistics transfer'}
                </Menu.Item>
                <Menu.Item key="transferCancelRequest">
                  {'Transfer cancel'}
                </Menu.Item>
                <Menu.Item key="offerRequest">{'Statistics offer'}</Menu.Item>
                <Menu.Item key="offerCancelRequest">{'Offer cancel'}</Menu.Item>
              </SubMenu>
            </Menu>
            <div className="sidebar__version">{`v. ${pkg.version}`}</div>
          </Sider>
          <Content className={'main-container'}>
            <Switch>
              <Route
                exact
                path="/admin/vdsTools/reportRequest"
                component={componentToFunction(Admin(VDSStatisticsSendView))}
              />
              <Route
                exact
                path="/admin/vdsTools/transferRequest"
                component={componentToFunction(
                  Admin(VDSTransmissionStatisticsView)
                )}
              />
              <Route
                exact
                path="/admin/vdsTools/transferCancelRequest"
                component={componentToFunction(
                  Admin(VDSTransmissionCancellationView)
                )}
              />
              <Route
                exact
                path="/admin/vdsTools/offerRequest"
                component={componentToFunction(
                  Admin(VDSSalesPromotionMessagesView)
                )}
              />
              <Route
                exact
                path="/admin/vdsTools/offerCancelRequest"
                component={componentToFunction(Admin(VDSSalesCancellationView))}
              />
            </Switch>
          </Content>
        </Layout>
      </Router>
    );
  }
}

export default withRouter(withTranslation('sidebar')(VDSTools));
